import React from 'react';

import ScanIqLogo from '../../../assets/image/scan-iq-logo.svg';

import classes from './ScanIqHeaderLogo.module.scss';
import { InBodyHeaderLogo } from '../InBodyHeaderLogo/InBodyHeaderLogo';

const ScanIqHeaderLogo = () => {
  return (
    <InBodyHeaderLogo>
      <img className={classes.logo} src={ScanIqLogo} alt="scan-iq" />
    </InBodyHeaderLogo>
  );
};

export { ScanIqHeaderLogo };
